import { Link } from 'react-router-dom'
import { useTranslation } from '@/i18n'

export function NotFoundPage() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-surface-950 px-4 text-center">
      <p className="mb-4 text-7xl font-black text-surface-700">404</p>
      <h1 className="mb-2 text-2xl font-bold text-surface-100">
        {t('Pagina niet gevonden')}
      </h1>
      <p className="mb-8 text-surface-400">
        {t('De pagina die je zoekt bestaat niet.')}
      </p>
      <Link
        to="/"
        className="rounded-xl border border-surface-700 px-5 py-2 text-sm font-medium text-surface-300 transition hover:border-surface-500 hover:text-surface-100"
      >
        {t('Terug naar home')}
      </Link>
    </div>
  )
}
